<template>
  <div id="riepilogoCarrello">
    <div v-if="qntyProd && qntyProd !== undefined" class="row">
      <div id="imgVino" class="col-lg-5 col-md-12 col-12">
        <img :src="'static/image/products/'+vino.image+'Shop.png'" v-if="vino.typology === 1" class="vinoimg">
        <img :src="'static/image/products/'+vino.image" v-if="vino.typology === 2" class="smartboximg">
      </div>
      <div class="col-lg-7 col-md-12 col-12" style="padding: 20px;">
        <div>{{vino.nome}}</div>
        <br>
        <div>{{vino.descr}}</div>
        <br>
        <div><span v-price>{{vino.price}}</span> x {{vino.qntyOrd}} = <span style="color: #ddc18f">{{subTot.toFixed(2)}} &euro;</span>
        </div>
        <br>
      </div>
    </div>
    <div v-if="!qntyProd && qntyProd !== undefined" class="row">
      <div id="imgVino" class="col-lg-5 col-md-12 col-12">
        <img :src="'static/image/products/'+vino.image+'Shop.png'" v-if="vino.typology === 1" class="notVinoimg">
        <img :src="'static/image/products/'+vino.image" v-if="vino.typology === 2" class="notSmartboximg">
      </div>
      <div class="col-lg-7 col-md-12 col-12" style="padding: 20px;">
        <div>{{vino.nome}}</div>
        <br>
        <div>{{vino.descr}}</div>
        <br>
        <div>
          <span v-price>{{vino.price}}</span> x {{vino.qntyOrd}} = <span style="color: #ddc18f">{{subTot.toFixed(2)}} &euro;</span>
          <div class="notAvailable" v-if="vino.typology === 1">Quantità non disponibile, per procedere all'acquisto di questo vino modifica la quantità o rimuovi il prodotto dal carrello</div>
          <div class="notAvailable" v-if="vino.typology === 2">Quantità non disponibile, per procedere all'acquisto di questo pacchetto modifica la quantità o rimuovi il prodotto dal carrello</div>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RiepilogoCarrello",
  data() {
    return {
      subTot: 0
    }
  },
  props: {
    vino: {type: Object},
    qntyProd: {type: Boolean}
  },
  mounted: function () {
    this.singlePrice()
  },
  methods: {
    singlePrice: function () {
      this.$http.get('/ws-shop/cart/singlePrice', {params: {idProduct: this.vino.idProduct, qntyOrd: this.vino.qntyOrd }}).then(response => {
        this.subTot = response.body.price
      })
    }
  }
}
</script>

<style lang="less">
  #riepilogoCarrello{
    .row{
      margin-right: 0px !important;
      margin-left: 0px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/RiepilogoCarrello.vue